module.exports = __webpack_public_path__ + "static/img/7.054b12a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/7.png
// module id = 86qh
// module chunks = 0